import Alpine from "alpinejs";

import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";
import "tippy.js/animations/scale.css";
import htmx from "htmx.org";

const tippyDropdown: Alpine.DirectiveCallback = (
  el,
  { expression },
  { cleanup }
) => {
  if (expression === undefined || expression.length === 0) {
    return;
  }

  const content = document.querySelector(expression);
  if (content === null) {
    console.error(`Dropdown content not found for selector: ${expression}`);
    return;
  }

  const item = tippy(el, {
    content,
    theme: "light",
    allowHTML: true,
    interactive: true,
    trigger: "click",
    placement: "bottom-start",
    onMount() {
      htmx.process(content)
    },
    onShow() {
      if (el.hasAttribute("aria-expanded")) {
        el.setAttribute("aria-expanded", "true");
      }
    },
    onHide() {
      if (el.hasAttribute("aria-expanded")) {
        el.setAttribute("aria-expanded", "false");
      }
    },
  });

  cleanup(() => {
    item.destroy();
  });
};

export default tippyDropdown;
